// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jRNl","toggle":"styles_toggle__1DEs9","preview":"styles_preview__3yGtH"};